import Swiper from 'swiper';
import Parallax from 'parallax-js';

let swiperRea = {
    init() {

        var swiper = new Swiper('.swiper-container.swiper-rea', {
            loop: true,
            autoplay: {
                delay: 3000,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            speed : 1200,
            autoHeight: true,
            on: {
                transitionStart: function () {
                    var color = $('.swiper-slide-active .metier').data('color');
                    $('.home .nos-realisations').css('background-color', color);
                    // $('.home .nos-realisations .rea').fadeOut(300);
                    // $('.home .nos-realisations .metier').fadeOut(300);
                    // $('.home .nos-realisations .picto').fadeOut(300);
                },
                // transitionEnd: function () {
                //     $('.home .nos-realisations .rea').fadeIn(300);
                //     $('.home .nos-realisations .metier').fadeIn(300);
                //     $('.home .nos-realisations .picto').fadeIn(300);
                // }
            },
        });
    }
}

export default swiperRea;
